import {Translations} from "./translations.model";
import {DistanceType} from "../types/distance.type";
import {CoordinatesModel} from "./coordinates.model";

export class TripModel extends CoordinatesModel {
  uid?: string;
  parentUid?: string;
  name?: Translations;
  description?: Translations;
  organizer?: string;
  joiners?: string[];
  type?: string[];
  startTimestamp?: number;
  arrivalTimestamp?: number;
  finishTimestamp?: number;
  order?: number;
  multiDay?: boolean;
  originalPoiRef?: {
    parent: string;
    child: string;
  };
  children?: TripModel[];
  distance?: DistanceType;
  images?: string[];

  constructor(that?: TripModel) {
    super();
    if (that) {
      this.uid = that.uid || this.uid;
      this.parentUid = that.parentUid || this.parentUid;
      this.name = that.name || this.name;
      this.description = that.description || this.description;
      this.organizer = that.organizer || this.organizer;
      this.joiners = that.joiners || this.joiners;
      this.type = that.type || this.type;
      this.startTimestamp = that.startTimestamp || this.startTimestamp;
      this.arrivalTimestamp = that.arrivalTimestamp || this.arrivalTimestamp;
      this.finishTimestamp = that.finishTimestamp || this.finishTimestamp;
      this.order = that.order || this.order;
      this.multiDay = that.multiDay || this.multiDay;
      this.originalPoiRef = that.originalPoiRef || this.originalPoiRef;
      this.children = that.children || this.children;
      this.distance = that.distance || this.distance;
      this.images = that.images || this.images;
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/models/trip.model.ts